import { render, staticRenderFns } from "./VExpertCompanies.vue?vue&type=template&id=531fd8f4&lang=pug"
import script from "./VExpertCompanies.vue?vue&type=script&lang=ts"
export * from "./VExpertCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports